import { render, staticRenderFns } from "./onlineOrder.vue?vue&type=template&id=ab43c552&scoped=true&"
import script from "./onlineOrder.vue?vue&type=script&lang=js&"
export * from "./onlineOrder.vue?vue&type=script&lang=js&"
import style0 from "./onlineOrder.vue?vue&type=style&index=0&id=ab43c552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab43c552",
  null
  
)

export default component.exports